// eslint-disable-next-line
// @ts-ignore
import { useApiClient } from '@brewardapp/api-client';
import { useStore } from '@breward/store';
import { MobileMenu } from '@breward/ui';
import SideMenu from '@breward/ui/components/SideMenu';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppHeader } from '@breward/ui';
import { Outlet, useNavigate } from 'react-router-dom';

// @ts-ignore
import logo from '#assets/logo.svg';

const AppLayout = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const clearStore = useStore((state) => state?.logoutUser);
  const [mobileMenuOpened, setMobileMenuOpened] = useState(false);

  const ITEMS = [
    {
      key: 'dashboard',
      icon: 'icon-[ph--house]',
    },
    {
      key: 'contests',
      icon: 'icon-[ph--certificate]',
    },
    {
      key: 'entries',
      icon: 'icon-[ph--beer-bottle]',
    },
    {
      key: 'orders',
      icon: 'icon-[ph--receipt]',
    },
    {
      key: 'profile',
      icon: 'icon-[ph--user-gear]',
    },
  ];

  const api = useApiClient();
  const logout = api.auth.useLogout();
  const { data: unreadCommentsData } = api.entries.useListEntries(
    {
      filter: {
        has_unread_comments: true,
      },
      page: { page: 1, size: 1 },
    }
  );

  const hasUnread = (unreadCommentsData?.meta?.totalEntries || 0) > 0;

  const itemsWithBadge = ITEMS.map((item) =>
    item.key === 'entries' ? { ...item, badge: hasUnread } : item
  );

  const handleLogout = () => {
    logout.mutate(
      {},
      {
        onSettled: () => {
          clearStore('/');
          navigate('/login');
        },
        onError: (error) => {
          console.log('error', error);
        },
      },
    );
  };

  return (
    <div className="from-primary-200 via-primary-100 to-primary-200 dark:from-content-950 dark:via-content-900 dark:to-primary-950 relative grid h-full min-h-screen grid-cols-12 bg-gradient-to-tr text-content-900 dark:text-content-100">
      <MobileMenu
        items={itemsWithBadge}
        opened={mobileMenuOpened}
        onClose={setMobileMenuOpened}
        onLogout={() => handleLogout()}
      />

      {/* App Header Component */}
      <AppHeader
        logoSrc={logo}
        showCommandPalette={false}
        onMenuClick={() => setMobileMenuOpened(true)}
      />

      {/* Side menu */}
      <div className="fixed left-0 top-14 bottom-0 z-20 hidden lg:block lg:w-16">
        <SideMenu items={itemsWithBadge} onLogout={() => handleLogout()} />
      </div>

      {/* Main content area */}
      <div className="relative col-span-12 lg:ml-16 pt-14 pb-8">
        <div className="mx-auto max-w-7xl px-4 lg:px-8 pt-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
